export const LOGIN_USER_REQUEST = 'LOGIN_USER'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST'
export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_ERROR = 'GET_USER_ERROR'
export const USER_TOKEN_EXPIRED_ERROR = 'USER_TOKEN_EXPIRED_ERROR'
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST'
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS'
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR'
export const GET_APPS_REQUEST = 'GET_APPS_REQUEST'
export const GET_APPS_SUCCESS = 'GET_APPS_SUCCESS'
export const GET_APPS_ERROR = 'GET_APPS_ERROR'
export const REFRESH_APPS_ARRAY = 'REFRESH_APPS_ARRAY'
export const REFRESH_ROLES_ARRAY = 'REFRESH_ROLES_ARRAY'
export const REFRESH_USERDETAILS = 'REFRESH_USERDETAILS'
export const SET_NO_ACCESS = 'SET_NO_ACCESS'
export const SET_MENU_LIST = 'SET_MENU_LIST'
export const SAVE_APP_FUNC_ARRAY = 'SAVE_APP_FUNC_ARRAY'
export const INCREMENT = 'INCREMENT'
